module.exports = __webpack_public_path__ + "cfp/Nick_Beede_Python Obfuscation and Evasion Techniques .pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Nick_Beede_Python Obfuscation and Evasion Techniques .pdf
// module id = 920
// module chunks = 0